import store from '@/store'

const { VUE_APP_TARGET } = process.env
const appInfo = {}
Object.keys(process.env).filter((item) => {
  // 筛选出NODE_ENV BASE_URL 以及所有以VUE_APP_开头的变量
  const v1 = item === 'NODE_ENV'
  const v2 = item === 'BASE_URL'
  const v3 = /^VUE_APP_/.test(item)
  return v1 || v2 || v3
}).forEach(item => {
  const obj = process.env
  let newItem = item
  // 将.env中的所有变量以APP_开头，存储到appInfo中
  if (/^VUE_APP_/.test(item)) {
    newItem = item.slice(4)
  } else {
    newItem = `APP_${item}`
  }
  // 这里将'YES'或者'NO'转化为boolean值
  if (obj[item] === 'YES') {
    appInfo[newItem] = true
  } else if (obj[item] === 'NO') {
    appInfo[newItem] = false
  } else {
    appInfo[newItem] = obj[item]
  }
})

// 读取 process.env 中的变量，将其存储到 store 中
store.commit('app/SAVE_APP_INFO', appInfo)

VUE_APP_TARGET !== 'PROD' && console.log(appInfo)
